const log10 = (n: number) => Math.log(n) / Math.log(10);

export default log10;
